import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-lg border border-background-300/40 bg-background-100/60 p-6 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/10 flex items-center justify-center shrink-0">
              <i className="ri-smartphone-line text-primary-400 text-3xl md:text-4xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
                {appInfo.title}
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                {appInfo.intro}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
                {appInfo.steps.map((step, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <span className="w-6 h-6 rounded-full bg-accent-500/20 text-accent-400 text-xs font-bold flex items-center justify-center shrink-0">
                      {idx + 1}
                    </span>
                    <span className="text-xs text-foreground-500">{step}</span>
                  </div>
                ))}
              </div>
              <p className="mt-4 text-xs text-accent-400 font-medium">{appInfo.feature}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}